import { CLUSTER } from '@/shared/config';

// Content hub markets: the FDA subsite is `us-fda`; the Americas clusters
// (us non-FDA, ca) share the `americas` market; the international version is
// `global`; ru maps to the CIS market.
export type KbMarket = 'us-fda' | 'global' | 'americas' | 'cis';

// Every market the hub serves, in the order the panel lists them.
export const KB_MARKETS: readonly KbMarket[] = [
  'global',
  'americas',
  'us-fda',
  'cis',
];

// A build without a region has no market of its own. It opens on the
// international market and lets the user switch.
export const DEFAULT_KB_MARKET: KbMarket = 'global';

export const getKbMarket = (isFDA: boolean): KbMarket | null => {
  switch (CLUSTER) {
    case 'us':
      return isFDA ? 'us-fda' : 'americas';
    case 'ca':
      return 'americas';
    case 'eu':
    case 'oceania':
      return 'global';
    case 'ru':
      return 'cis';
    default:
      return null;
  }
};
